import {useState,useEffect, useRef} from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { ArrowDropDown,AddCircleOutline, HighlightOff } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { setHeader,setImgHeader } from '../services/Headers'
import { Url } from '../services/Constants'
import toast from 'react-hot-toast'

export default function UpdateProduct() {

    const id = useParams() 
    
    const selectCategory = useRef()
    const [categorymenu, setCategorymenu] = useState(false)
    const [categorymenudata, setCategorymenudata] = useState("Select Category")
    const [gstmenu, setGstmenu] = useState(false) 
    const [gstmenudata, setdGstMenuData] = useState("Select GST")
    const [isPreviewImg, setIsPreviewImg] = useState(false)
    const [imagePreviews, setImagePreviews] = useState([]);
    const [isSoloImage, setIsSoloImage]  = useState(null)
    const [is_variant,setis_variant] = useState(false)
    const [product_variants_attributes, setVariants] = useState([{id:'', category_id:'', left_qty: '', price: '', discounted_price: '', product_code:'', seller_id:'', weight:'',height:'',breadth:'', length:'', }]);
    const Navigate = useNavigate()
    const [category_id,setCategoryId] = useState()
    const [profile,setProfile] = useState()
    const [productName,setProductName] = useState()
    const [specification,setSpecification] = useState()
    const [images,setImages] = useState([])
    const [productData,setProductData] = useState()
    const [newVarients,setNewVarients] = useState([])


    useEffect(() => {


        

        const checkPreLogin = async () => {
            try {
                const result = await axios.get(`${Url}/seller/get_profile`, setHeader());
                const user = result.data.response_code;
                setProfile(result.data.response_data)
                if (user===400) {
                    Navigate("/")
                }
                else{
                    const productData = await axios.get(`${Url}/seller/products/${id.id}`,setHeader())
                    setProductData(productData)
                    if(productData.data.response_code===200){
                        setProductName(productData.data.response_data.name)
                        setCategoryId(productData.data.response_data.category_id)
                        setSpecification(productData.data.response_data.specification)
                        setis_variant(productData.data.response_data.is_variant)
                        setdGstMenuData(productData.data.response_data.gst)
                        const serverImg = productData.data.response_data.product_images.map((preview, index) => {
                            return preview.image
                        })
                        setImagePreviews(serverImg)
                        setIsPreviewImg(true)
                        setVariants(productData.data.response_data.product_variants)
                        selectCategory.current.innerText = productData.data.response_data.category_name


                    }
                    else{
                        Navigate("/")
                    }
                }
            }catch(error){
                console.log(error)
            }        
           
        };
        checkPreLogin()
    

        return () => {
          imagePreviews.forEach((preview) => URL.revokeObjectURL(preview));
        };
      }, []);



    const categoryHandle = (e)=>{
        e.preventDefault()
        setCategorymenudata(e.target.innerText)
        setCategoryId(Number(e.target.id))
        setCategorymenu(!categorymenu)
    }

    const gstHandle = (e)=>{
        e.preventDefault()
        setdGstMenuData(e.target.innerText)
        setGstmenu(!gstmenu)
    }
    

    const handleFileChange = (e)=>{
        
        const files = e.target.files;
        const fileArray = Array.from(files); 
        setImages(fileArray)
        const previewArray = [];
        fileArray.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                previewArray.push(reader.result); 
                if (previewArray.length === fileArray.length) {
                    setImagePreviews((prevPreviews) => [...prevPreviews, ...previewArray]);
                    setIsPreviewImg(true);
                }
            };
            reader.readAsDataURL(file);
        });

    }

    const handleDelete = (previewUrl) => {
        setImagePreviews((prevPreviews) =>
            prevPreviews.filter((url) => url !== previewUrl)
        );
        if (imagePreviews.length === 1) {
            setIsPreviewImg(false);
        }
        setIsSoloImage(null)
      };

    const handleImageView = (e)=>{
        setIsSoloImage(e.target.src)
      }



      const handleVariantChange = (index, field, value) => {
          let updatedVariants = [...product_variants_attributes];
        //   if (field === 'left_qty') {
        //     delete updatedVariants[index]["left_qty"];
        //     updatedVariants[index][field]=value
        //   } else {
        //     updatedVariants[index][field] = value;
        //   }
            // updatedVariants[index][field] = value;
            updatedVariants[index][field] = value;

            // Ensure left_qty is not set to undefined
            if (field !== 'left_qty' && updatedVariants[index]['left_qty'] === undefined) {
                updatedVariants[index]['left_qty'] = '';
            }
            setVariants(updatedVariants)
            setNewVarients(updatedVariants);
      };

      const addVariant = () => {
        setVariants([...product_variants_attributes, { category_id:category_id, left_qty: "", price: '', discounted_price: '', product_code:'', seller_id:profile.seller_id, weight:'',height:'',breadth:'', length:'' }]);
      };
      
      const removeVariant = (index) => {
        const updatedVariants = product_variants_attributes.filter((_, idx) => idx !== index);
        setVariants(updatedVariants);
        setNewVarients(updatedVariants);
      };


      
      const dataSubmitHandle = async() =>{
        const hasNegativePrice = product_variants_attributes.some(variant =>
            (variant.price < 0 || variant.discounted_price < 0 || variant.available_quantity < 0 || variant.weight < 0 || variant.height < 0 || variant.breadth < 0 || variant.length < 0)
        );

        if (hasNegativePrice) {
            toast.error("value can not be in minus.");
            return;
        }
        if(productName && category_id!==undefined && category_id!== "0" && gstmenudata !== "Select GST" && specification){
            
            if(newVarients.length===0){
                setNewVarients(product_variants_attributes)
            }
            
            const formData = new FormData();


            formData.append('product[name]', productName);
            formData.append('product[specification]', specification);
            formData.append('product[category_id]', category_id);
            formData.append('product[is_variant]', is_variant);
            formData.append('product[gst]', gstmenudata);
            newVarients.forEach((variant, index) => {
                formData.append(`product[product_variants_attributes][${index}][id]`, variant.id);
                formData.append(`product[product_variants_attributes][${index}][category_id]`, category_id);
                formData.append(`product[product_variants_attributes][${index}][available_quantity]`, variant.left_qty);
                formData.append(`product[product_variants_attributes][${index}][price]`, variant.price);
                formData.append(`product[product_variants_attributes][${index}][discounted_price]`, variant.discounted_price);
                formData.append(`product[product_variants_attributes][${index}][product_code]`, variant.product_code);
                formData.append(`product[product_variants_attributes][${index}][seller_id]`, variant.seller_id);
                formData.append(`product[product_variants_attributes][${index}][weight]`, variant.weight);
                formData.append(`product[product_variants_attributes][${index}][height]`, variant.height);
                formData.append(`product[product_variants_attributes][${index}][breadth]`, variant.breadth);
                formData.append(`product[product_variants_attributes][${index}][length]`, variant.length);
              });
            images.forEach((image) => {
                formData.append("product[product_images][]", image);
              });
    
            try {
                const result =await axios.put(`${Url}/seller/products/${id.id}`,formData,setImgHeader())
                if(result.data.response_code===400){
                    toast.error("Please enter all varients details!")
                }else{
                    toast.success("Product added successfully.")
                    Navigate(`/product-detail/${id.id}`)
                }
            } catch (error) {
                console.log(error)
            }


            
        }else{
            if(!productName){
            toast.error("Please enter product name!")
            return
            }
            if(category_id===undefined||category_id==="0"){
            toast.error("Please select category!")
            return
            }
            if(gstmenudata==="Select GST"){
            toast.error("Please select GST!")
            return
            }
            if(!specification)
            {
            toast.error("Please enter product specification!")
            return
            }
        }
    }

    // console.log(product_variants_attributes)

    

  return (
    <div className="product-container">
    <div className="product-top">
      <Navbar />
    </div>
    <div className="product-feed relative z-10 w-[70%] mx-auto top-3 mb-40  py-1 bg-slate-100 flex max-sm:flex-col">
        <div className="image-work w-full lg:w-1/2 flex flex-row items-center">
    {isPreviewImg?<div className="preview-image bg-slate-200 max-w-16 px-1 pt-1 overflow-y-auto max-h-96 object-cover mr-2">
                {imagePreviews.map((preview, index) => (
                <div key={index} className="relative mb-3">
                <img
                src={preview.id?preview.image:preview}
                alt={`Preview ${index}`}
                className="w-16 h-10 object-cover border rounded cursor-pointer"
                onClick={handleImageView}
                />
                <button
                onClick={() => handleDelete(preview)}
                className="absolute top-0 right-0 w-4 h-4 bg-red-500 text-[10px] text-white rounded-full"
                >
                X
                </button>
                </div>
                ))}
            </div>:""}
            {!isSoloImage?<div className="add-product-left bg-slate-200 w-[90%] min-h-96 flex py-5 items-center justify-center max-sm:w-[90%] max-sm:h-40">
            <input type="file" multiple accept='image/' id="icon-button" className="upload__inputfile hidden" onChange={handleFileChange}/>
            <label class="upload__btn flex flex-col justify-center items-center text-amber-950 cursor-pointer font-bold" htmlFor="icon-button">
            <div className="add-btn text-5xl border-2 border-amber-950 px-3 pb-2 rounded-lg">+</div>
            <p className='add-btn-title '>Product Images</p>
            </label>
            </div>:
            <div className="add-product-left relative bg-slate-200 w-[90%] flex flex-col items-center justify-center max-sm:w-[90%] max-sm:h-40">
              <img src={isSoloImage} alt="image.jpg" />
              <button
                onClick={() => setIsSoloImage(null)}
                className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-sm font-bold text-white mx-auto rounded-full"
                >
                X
                </button>
            </div>}
            </div>

            <div className="add-product-right w-full lg:w-1/2 mx-auto max-sm:w-[90%] max-lg:w-[90%] max-sm:mx-auto max-sm:mt-4">
                            {/* <form action="" className="add-product-form flex flex-col items-center text-amber-950"> */}
                            <div className="product-name w-[90%] mx-auto mb-3 mt-3">
                           <input type="text" name="" id="" defaultValue={productName} className=" w-full py-[1.5%] px-[1.5%] outline-none border border-amber-950 rounded-md " placeholder='Product Name' onChange={(e)=>setProductName(e.target.value)}/>
                            </div>
                           <div className="category-container w-[90%] mx-auto relative">
                           <div class="category-button control-form w-full border border-amber-950 rounded-md py-[1.5%] px-[1.5%] mb-3 cursor-pointer flex justify-between" onClick={()=>setCategorymenu(!categorymenu)}>
                            <span className="" ref={selectCategory}>{categorymenudata}</span>
                            <ArrowDropDown/>
                           </div>
                            {categorymenu?<ul class="category-menu p-[1%] pl-[2%] z-10 absolute bg-white border shadow-lg border-amber-950 rounded-md w-full -mt-2 max-sm:w-full">
                             <li id='0' className='mb-1 cursor-pointer' onClick={categoryHandle}>Select Category </li>
                             <li id="11" className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Cutting Tool </li>
                             <li id='12' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Hardware & Fitting</li>
                             <li id='13' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Adhesive</li>
                             <li id='14' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Spare Part</li>
                             <li id='15' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Service of Machine</li>
                             <li id='16' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Regrinding Blade Tools</li>
                             <li class="divider"></li>                           
                           </ul>:"" } 
                           </div>
                           <div className="gst-container w-[90%] mx-auto relative">
                           <div className="gst-button w-full border border-amber-950 rounded-md py-[1.5%] px-[1.5%] mb-3 cursor-pointer flex justify-between" onClick={()=>setGstmenu(!gstmenu)} >
                            <span className="k">{gstmenudata}</span>
                            <ArrowDropDown/>
                            </div>  
                            {gstmenu?<ul class="gst-menu p-[1%] pl-[2%] z-10 absolute bg-white border shadow-lg border-amber-950 rounded-md w-full -mt-2 max-sm:w-full" >
                             <li className='mb-1 cursor-pointer' onClick={gstHandle}>Select GST </li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>5% </li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>12%</li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>18%</li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>28%</li>                         
                           </ul>:""}
                           </div>
                           <div className="is_variant-container w-[90%] mx-auto mb-3 flex items-center ">
                           <input type="checkbox" name="is_variant" id="is_variant" checked={is_variant} value={true} className=" " onChange={()=>setis_variant(!is_variant)} />
                           <label htmlFor="is_variant" className="ml-2">Is varient</label> 
                           {is_variant?<AddCircleOutline className='ml-5 cursor-pointer hover:text-amber-950' onClick={addVariant}/>:""}
                            </div>  
                                

                           {/* product_variants_attributes ittration */}
                           <div className=' h-32 overflow-y-auto'>
                           {product_variants_attributes.length>0?product_variants_attributes.map((varient,index)=>(<div className="product_variants_attributes flex w-full mb-3 justify-end max-sm:flex-col items-end max-sm:w-full">
                           {index!==0?<HighlightOff className='cursor-pointer' onClick={()=>removeVariant(index)}/>:""}
                           <div key={index} className="size flex flex-col w-[12%] items-center max-sm:w-full ">
                                <span className="title max-sm:w-[90%] max-sm:text-start">Product Code</span>
                                <input type="text" name="" id={varient.id} defaultValue={varient.product_code} className='outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]' onChange={(e) => handleVariantChange(index, 'product_code', e.target.value)}/>
                            </div>
                            <div className="qty flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start">Qty</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.left_qty} className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'left_qty', e.target.value)}/>
                            </div>
                            <div className="price flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start">Price</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.price} className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'price', e.target.value)}/>
                            </div>
                            <div className="discount flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start md:w-full md:text-center">Offer Price</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.discounted_price} className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'discounted_price', e.target.value)}/>
                            </div>
                            <div className="qty flex flex-col max-w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start">{`Weight (gm)`}</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.weight} className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'weight', e.target.value)} />
                            </div>
                            <div className="price flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title  max-sm:w-[90%] max-sm:text-start">{`Height (cm)`}</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.height} className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'height', e.target.value)}/>
                            </div>
                            <div className="discount flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start md:w-full md:text-center">{`Width (cm)`}</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.breadth} className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'breadth', e.target.value)}/>
                            </div>
                            <div className="size flex flex-col w-[12%] items-center max-sm:w-full ">
                                <span className="title max-sm:w-[90%] max-sm:text-start">{`Length (cm)`}</span>
                                <input type="number" name="" id={varient.id} defaultValue={varient.length} className='outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]' onChange={(e) => handleVariantChange(index, 'length', e.target.value)}/>
                            </div>
                           </div>)):""}
                           </div>

                           <div className="specificaion w-[90%] mx-auto flex flex-col mb-5 ">
                            <span className="k mb-2" >Specification</span>
                            <textarea name="" id="" defaultValue={specification} className='outline-none border border-amber-950 rounded-md p-[2%] text-sm h-[30%] resize-none' onChange={(e)=>{setSpecification(e.target.value)}}></textarea>
                           </div>
                {/* </form> */}
                <div className="buttons flex w-[40%] justify-around mx-auto">
                    <div className="submit bg-amber-950 rounded-lg text-white px-2 py-1 cursor-pointer hover:text-gray-400" onClick={dataSubmitHandle}>Update Product</div>
                    <div className="cancele bg-amber-950 rounded-lg text-white px-2 py-1 cursor-pointer hover:text-gray-400" onClick={()=>Navigate(-1)}>Cancel</div>
                </div>
    </div>
    </div>

    

    <div className=" product-bottom z-10 mb-0">
      <Footer/>
    </div>
  </div>
  )
}
